import React, { useEffect, useState } from 'react';
import {
  ActionButton,
  CountdownPill,
  HelpText,
  QrImage,
  QrWrapper,
  SectionTitle,
  TextMono
} from '../styles';

type Props = {
  pixQrCode?: string;
  pixQrCodeUrl?: string;
  pixCopyPaste?: string;
  expiresAt?: string;
  onCopy: (value: string) => void;
};

const pickCopyPayload = (pixCopyPaste?: string, pixQrCode?: string): string => {
  for (const x of [pixCopyPaste, pixQrCode]) {
    const t = (x || '').trim();
    if (t) return t;
  }
  return '';
};

const dataForGeneratedQr = (pixCopyPaste?: string, pixQrCode?: string): string => {
  const p = (pixCopyPaste || '').trim();
  const q = (pixQrCode || '').trim();
  if (p) return p;
  if (q) return q;
  return '';
};

const PixPaymentView: React.FC<Props> = ({
  pixQrCode,
  pixQrCodeUrl,
  pixCopyPaste,
  expiresAt,
  onCopy
}) => {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!expiresAt) return;
    const id = window.setInterval(() => setTick(t => t + 1), 1000);
    return () => window.clearInterval(id);
  }, [expiresAt]);

  let countdown: 'expired' | string | null = null;
  if (expiresAt) {
    const now = Date.now() - 0 * tick;
    const diffMs = new Date(expiresAt).getTime() - now;
    if (Number.isNaN(diffMs) || diffMs <= 0) {
      countdown = 'expired';
    } else {
      const minutes = Math.floor(diffMs / 60000);
      const seconds = Math.floor((diffMs % 60000) / 1000);
      countdown = `${minutes}m ${seconds}s`;
    }
  }

  const copyablePayload = pickCopyPayload(pixCopyPaste, pixQrCode);
  const forQr = dataForGeneratedQr(pixCopyPaste, pixQrCode);
  const qrSource =
    (pixQrCodeUrl && pixQrCodeUrl.trim()) ||
    (forQr
      ? `https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(forQr)}`
      : '');

  return (
    <>
      <SectionTitle>Pagamento via Pix</SectionTitle>

      {countdown === 'expired' && (
        <CountdownPill>
          <span>Prazo do Pix encerrado.</span>
        </CountdownPill>
      )}
      {countdown && countdown !== 'expired' && (
        <CountdownPill>
          <span>Tempo restante:</span>
          <strong>{countdown}</strong>
        </CountdownPill>
      )}

      {qrSource && (
        <QrWrapper>
          <QrImage src={qrSource} alt="QR Code para pagamento Pix" />
        </QrWrapper>
      )}

      {copyablePayload ? (
        <>
          <HelpText>

            <>
              Copie o código abaixo e cole no app do seu banco em{' '}
              <strong>Pix copia e cola</strong>.
            </>
          </HelpText>
          <TextMono>{copyablePayload}</TextMono>
          <ActionButton type="button" onClick={() => onCopy(copyablePayload)}>
            Copiar código Pix
          </ActionButton>
        </>
      ) : (
        <HelpText>
          O <strong>Pix copia e cola</strong> (código EMV) ainda não está disponível nesta
          cobrança. Use o QR Code acima ou, se tiver o link de pagamento do banco, abra no
          celular. Se o problema continuar, fale com quem enviou a cobrança.
        </HelpText>
      )}
    </>
  );
};

export default PixPaymentView;
